// A storage object key is not a browser URL. The report backend must supply
// a readable URL (including signing/proxying when the asset is private).
export const reportPhotoSource = (person) => {
  if (person?.photo?.available === false) return undefined;
  const explicit =
    person?.avatar_url || person?.photo_url || person?.photo?.url;
  if (explicit) return explicit;
  const path = person?.photo?.path;
  return typeof path === "string" && /^https?:\/\//i.test(path)
    ? path
    : undefined;
};
